import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';

export const useKeySellingPointsFeature = () => {
  const { cartFeatures } = useShoppingCart();

  const hasKeySellingPointsFeature = cartFeatures?.find(
    (feature) => feature?.type === 'BulletPoints',
  );

  return Boolean(hasKeySellingPointsFeature);
};
